import { Component } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-admin-pro',
  templateUrl: './admin-pro.component.html',
  styleUrls: ['./admin-pro.component.scss']
})
export class AdminProComponent {
  tabIndex:any;
  
  constructor(public api:ApiService) { }


  ngOnInit(){}
}
